import {Pipe, PipeTransform} from '@angular/core';
import {Benutzer} from '../../../clients/veranstaltungen';

@Pipe({
    name: 'displaybenutzer',
    pure: false
})
export class DisplayBenutzerPipe implements PipeTransform {
    constructor() {}

    static getDisplayBenutzerText(benutzerId: string, benutzer: Benutzer, format?: number) {
        if (benutzerId !== null && benutzer === null) {
            return 'Benutzer ausgeschieden?';
        } else if (benutzer !== null && benutzer !== undefined) {
            if (format === 1) {
                return benutzer.display_vorname_nachname;
            } else if (format === 2) {
                return benutzer.display_nachname_vorname;
            } else {
                // Standard
                return benutzer.display_vorname_nachname;
            }
        } else {
            return '';
        }
    }

    transform(benutzerId: string, benutzer: Benutzer, format?: number) {
        return DisplayBenutzerPipe.getDisplayBenutzerText(benutzerId, benutzer, format);
    }
}


